import "../projects.css";

function StudentHub() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="/assets/projects/StudentHubRedesign.png"
          alt="Student Hub Redesign"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Student Hub Redesign</h1>
        <p className="project-subtitle">
          Reimagining Northeastern’s Student Hub for faster navigation, clearer resources, and a branded experience students actually want to use.
        </p>
        <div className="badge-container">
          <span className="badge">UI/UX Design</span>
          <span className="badge">Prototyping</span>
          <span className="badge">User Research</span>
          <span className="badge">Figma</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">🧭</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Led UX research and prototyping. I conducted student interviews, synthesized feedback, and built a clickable redesign.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Short sprint that involved auditing the current hub, conducting user interviews, and iterating on a Figma prototype that captures Northeastern's brand.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Focus</h3>
            <ul className="overview-list">
              <li>Resource hub clarity and navigation</li>
              <li>School-branded look and feel</li>
              <li>Prototype ready for quick usability checks</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">Design Challenge</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            Students rely on the Hub for everything from meal plans to registration, but the current experience feels unbranded and hard to scan. The redesign needed to make the resources page clearer, faster to use, and reflective of Northeastern’s identity.
          </p>
          <p className="case-study-text">
            I tightened the information architecture, refreshed the visual system, and prototyped a streamlined flow that surfaces the most-used links first while keeping the rest easy to find.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Focused On</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">🧭</span>
                <div className="value-content">
                  <strong>Navigation Clarity</strong>
                  <span className="value-text">Reorganized and grouped resources so the most-used links are immediately visible.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎨</span>
                <div className="value-content">
                  <strong>On-Brand UI</strong>
                  <span className="value-text">Introduced Northeastern-inspired visuals to give the hub a cohesive, branded identity.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">⚡</span>
                <div className="value-content">
                  <strong>Fast Paths</strong>
                  <span className="value-text">Created a lean prototype to validate quick paths for common student tasks.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Screens */}
      <div className="case-study-section">
        <div className="case-study-content">
          <div className="row" style={{ display: "flex", gap: "1.5rem", justifyContent: "center", flexWrap: "wrap" }}>
            <img
              src="/assets/projects/redesign3.png"
              alt="Student Hub redesign screens"
              style={{ maxWidth: "46%", minWidth: "280px" }}
            />
            <img
              src="/assets/projects/redesign2.png"
              alt="Student Hub redesign screens"
              style={{ maxWidth: "46%", minWidth: "280px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentHub;
